import { createAction, props } from '@ngrx/store';
import { Facility } from '../../model/facility.model';
import { CreateFacilityRequest } from '../../model/create-facility-request.model';
import { FacilityGroup } from 'brain-data/model/facility-group.model';
import { FacilityPerformanceYearly, FacilitySolarPerformance } from 'brain-data/model/facility-performance.model';
import { AlertNotification } from 'brain-data/model/alert.model';
import { UpdateFacilityGroupRequest } from 'brain-data/message/update-facility-group-request.model';
import { Building } from '../../model/building.model';
import { FacilityGroupOnboardingCache } from '../../model/onboarding.model';

// FACILITIES

export const loadFacilityGroups = createAction('[Facility Groups] load');
export const loadFacilityGroupsSuccess = createAction('[Facility Groups] load success', props<{ facilityGroups: FacilityGroup[] }>());
export const loadFacilityGroupsError = createAction('[Facility Groups] load error', props<{ error: Error }>());

export const updateFacilityGroup = createAction(
  '[Update] facility group',
  props<{ facilityGroupId: number; updateFacilityGroupRequest: UpdateFacilityGroupRequest }>(),
);
export const updateFacilityGroupSuccess = createAction(
  '[FacilityGroup] Update Facility Group Success',
  props<{ facilityGroupId: number; updatedFacilityGroup: FacilityGroup }>(),
);
export const updateFacilityGroupError = createAction('[Update] facility group error', props<{ error: Error }>());

export const loadFacilities = createAction('[Facilities] load facilities');
export const loadFacilitiesSuccess = createAction('[Facilities] load facilities success', props<{ facilities: Facility[] }>());
export const loadFacilitiesError = createAction('[App] load facilities error', props<{ error: Error }>());

export const loadFacilitiesAndSetCurrentFacilityById = createAction(
  '[Facilities] load facilities and set current facility by id',
  props<{ facilityId: number }>(),
);
export const loadFacilitiesAndSetCurrentFacilityByIdSuccess = createAction(
  '[Facilities] load facilities  and set current facility by id success',
  props<{ facilities: Facility[]; facilityId: number }>(),
);
export const loadFacilitiesAndSetCurrentFacilityByIdError = createAction(
  '[[Facilities] load facilities  and set current facility by id success error',
  props<{ error: Error }>(),
);

export const updateFacilities = createAction('[Facilities] update facilities', props<{ facilities: Facility[] }>());

export const createFacility = createAction(
  '[Facilities] create facility',
  props<{ request: CreateFacilityRequest }>(),
);
export const createFacilitySuccess = createAction(
  '[Facilities] create facility success',
  props<{ facility: Facility }>(),
);
export const createFacilityError = createAction(
  '[Facilities] create facility error',
  props<{ error: Error }>(),
);

export const loadFacilityById = createAction('[Facilities] load facility by id', props<{ facilityId: number }>());
export const loadFacilityByIdSuccess = createAction('[Facilities] load facility by id success', props<{ facility: Facility }>());
export const loadFacilityByIdError = createAction('[Facilities] load facility by id error', props<{ error: Error }>());

export const loadFacilityPerformancesBuildingByFacilityGroupId = createAction(
  '[Facility Performances] Load FacilityPerformance Building for FacilityGroupId',
  props<{ facilityGroupId: number }>(),
);
export const loadFacilityPerformancesBuildingByFacilityGroupIdSuccess = createAction(
  '[Facility Performances] Load FacilityPerformance Building for FacilityGroupId Success',
  props<{ facilityGroupPerformance: FacilityPerformanceYearly[] }>(),
);
export const loadFacilityPerformancesBuildingByFacilityGroupIdError = createAction(
  '[Facility Performances] Load FacilityPerformanceBuilding for FacilityGroupId Error',
  props<{ error: Error }>(),
);

export const loadFacilityPerformanceBuildingByFacilityId = createAction(
  '[Facility Performances] Load FacilityPerformance Building for FacilityId',
  props<{ facilityId: number }>(),
);
export const loadFacilityPerformanceBuildingByFacilityIdSuccess = createAction(
  '[Facility Performances] Load FacilityPerformance Building for FacilityId Success',
  props<{ facilityPerformance: FacilityPerformanceYearly }>(),
);
export const loadFacilityPerformanceBuildingByFacilityIdError = createAction(
  '[Facility Performances] Load FacilityPerformance Building for FacilityId Error',
  props<{ error: Error }>(),
);

export const loadFacilityPerformanceSolarByFacilityId = createAction(
  '[Facility Performances] Load FacilityPerformance Solar for FacilityId',
  props<{ facilityId: number }>(),
);
export const loadFacilityPerformanceSolarByFacilityIdSuccess = createAction(
  '[Facility Performances] Load FacilityPerformance Solar for FacilityId Success',
  props<{ facilitySolarPerformance: FacilitySolarPerformance[] }>(),
);
export const loadFacilityPerformanceSolarByFacilityIdError = createAction(
  '[Facility Performances] Load FacilityPerformance Solar for FacilityId Error',
  props<{ error: Error }>(),
);

export const loadFacilityPerformanceSolarByFacilityGroupId = createAction(
  '[Facility Performances] Load FacilityPerformance Solar for FacilityGroupId',
  props<{ facilityGroupId: number }>(),
);
export const loadFacilityPerformanceSolarByFacilityGroupIdSuccess = createAction(
  '[Facility Performances] Load FacilityPerformance Solar for FacilityGroupId Success',
  props<{ facilitySolarPerformance: FacilitySolarPerformance[] }>(),
);
export const loadFacilityPerformanceSolarByFacilityGroupIdError = createAction(
  '[Facility Performances] Load FacilityPerformance Solar for FacilityGroupId Error',
  props<{ error: Error }>(),
);

//Combined Actions

export const loadFacilitiesAtStartup = createAction('[Data] Init Facilities at startup');
export const loadFacilitiesAtStartupSuccess = createAction(
  '[Data] Init Facilities at startup Success',
  props<{ facilities: Facility[]; facilityGroups: FacilityGroup[] }>(),
);
export const loadFacilitiesAtStartupError = createAction('[Data] Init Facilities at startup error', props<{ error: Error }>());

export const setCurrentFacilityGroup = createAction('[Facility Group] set current facility group', props<{ facilityGroup: FacilityGroup }>());

export const clearCurrentFacilityGroup = createAction('[Facility Group] clear current facility group');

export const setCurrentGroupAndFacilityByIds = createAction(
  '[Facility] set current group and facility by id',
  props<{ facilityGroupId: number; facilityId: number }>(),
);

export const setCurrentFacilityGroupById = createAction('[Facility] set current facility group by id', props<{ facilityGroupId: number }>());
export const setCurrentFacilityById = createAction('[Facility] set current facility by id', props<{ facilityId: number }>());

export const updateFacilityAlertWithSnooze = createAction(
  '[Facility] Update Alert With Snooze and Optional Notification',
  props<{ alertId: number; snoozedUntil: string; alertNotification?: AlertNotification }>(),
);

export const updateFacilityAlertUnsnoozed = createAction('[Facility] Update Alert Unsnoozed', props<{ alertId: number }>());

export const updateFacilityAlertsClosed = createAction('[Facility] Update Alerts Closed', props<{ alertIds: number[] }>());

export const updateFacilityAlertReopened = createAction('[Facility] Update Alert Reopened', props<{ alertId: number }>());

export const updateFacility = createAction('[Facility] update', props<{ facilityId: number; facility: Facility }>());
export const updateFacilitySuccess = createAction('[Facility] update success');
export const updateFacilityError = createAction('[Facility] update error', props<{ error: Error }>());

export const createFacilityGroupsFromOnboarding = createAction('[Facility Groups] Create from onboarding', props<{ groups: FacilityGroupOnboardingCache[] }>());
export const createFacilityGroupsFromOnboardingSuccess = createAction('[Facility Groups] Create from onboarding success');
export const createFacilityGroupsFromOnboardingError = createAction('[Facility Groups] Create from onboarding error', props<{ error: Error }>());

export const addFacilityBuildings = createAction(
  '[Facility] add buildings',
  props<{
    facilityId: number;
    buildings: { name: string; latitude: number; longitude: number; yearBuilt?: number; grossArea?: number; vacant?: boolean }[];
  }>(),
);
export const addFacilityBuildingsSuccess = createAction('[Facility] add buildings success', props<{ facilityId: number; buildings: Building[] }>());
export const addFacilityBuildingsError = createAction('[Facility] add buildings error', props<{ error: Error }>());

export const updateFacilityBuildings = createAction(
  '[Facility] update buildings',
  props<{
    facilityId: number;
    buildings: { id: number; name: string; latitude: number; longitude: number; yearBuilt?: number; grossArea?: number; vacant?: boolean }[];
  }>(),
);
export const updateFacilityBuildingsSuccess = createAction('[Facility] update buildings success', props<{ facilityId: number; buildings: Building[] }>());
export const updateFacilityBuildingsError = createAction('[Facility] update buildings error', props<{ error: Error }>());

export const deleteFacilityBuildings = createAction('[Facility] delete buildings', props<{ facilityId: number; ids: number[] }>());
export const deleteFacilityBuildingsSuccess = createAction('[Facility] delete buildings success', props<{ facilityId: number; ids: number[] }>());
export const deleteFacilityBuildingsError = createAction('[Facility] delete buildings error', props<{ error: Error }>());

// Building Utility Contracts
export const linkUtilityContractsToBuilding = createAction(
  '[Facility] link utility contracts to building',
  props<{ facilityId: number; buildingId: number; contractNumbers: string[] }>(),
);
export const linkUtilityContractsToBuildingSuccess = createAction('[Facility] link utility contracts to building success');
export const linkUtilityContractsToBuildingError = createAction('[Facility] link utility contracts to building error', props<{ error: Error }>());

export const unlinkUtilityContractsFromBuilding = createAction('[Facility] unlink utility contracts from building', props<{ contractNumbers: string[] }>());
export const unlinkUtilityContractsFromBuildingSuccess = createAction('[Facility] unlink utility contracts from building success');
export const unlinkUtilityContractsFromBuildingError = createAction('[Facility] unlink utility contracts from building error', props<{ error: Error }>());
